import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'relative',
    paddingTop: '$xl',
    paddingBottom: '$xl',
    paddingLeft: 'calc(5 * $colWidth)',
    paddingRight: 'calc(5 * $colWidth)',
    minHeight: 700,
    height: '100vh',

    '@mdDown': {
        paddingLeft: '$sm',
        paddingRight: '$sm',
    },
})

export const Content = styled('div', {
    width: 'calc(7 * $colWidth)',
    position: 'relative',
    zIndex: 10,
    '@mdDown': {
        width: '100%',
        paddingTop: '$md',
    },
})

export const Images = styled('div', {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',

    display: 'grid',

    gridTemplateColumns:
        '0 calc(3 * $colWidth) calc(11 * $colWidth) calc(5 * $colWidth) $colWidth calc(4 * $colWidth)',
    gridTemplateRows: '30vh 10vh 40vh 20vh',

    '& > img:first-child': {
        gridColumnStart: 2,
        gridRowStart: 3,
        width: 'calc(3 * $colWidth)',
        height: 'auto',
    },
    '& > img:nth-child(2)': {
        gridColumnStart: 4,
        gridRowStart: 2,
        width: 'calc(5 * $colWidth)',
        height: 'auto',
    },
    '& > img:last-child': {
        gridColumnStart: 6,
        gridRowStart: 4,
        width: 'calc(4 * $colWidth)',
        height: 'auto',
    },
})
